import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/advertising_spaces',
  component: Management,
  redirect: '/advertising_spaces/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/advertising_spaces/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listAdvertisements
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/advertising_spaces/ListTable'),
          meta: {
            auth: Auth.listAdvertisements,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
